module.exports = __webpack_public_path__ + "img/ruoyi8.59ef50cc.png";